import { Checkbox } from 'antd';
import React from 'react';

export const LCCheckbox = props => <Checkbox {...props} />;
